module.exports = __webpack_public_path__ + "img/clear@3x.0e82455a.png";